import React, { useState, useEffect } from 'react'
import './Register.css'
import Footer from '../../shared/components/UIElements/Footer'
import Button from '../../shared/components/UIElements/Button'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import Modal from '../../shared/components/UIElements/Modal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useNavigate } from 'react-router-dom'
//import { REACT_APP_PAYPAL_CLIENT_ID } from '../../Config/config'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
//const { PAYPAL_CLIENT_ID } = process.env

const Register = () => {
	//console.log('PAYPAL_CLIENT_ID: ' + PAYPAL_CLIENT_ID)
	//console.log('PAYPAL_CLIENT_ID 2: ' + process.env.REACT_APP_PAYPAL_CLIENT_ID)

	const [type, setType] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [showSuccessfulPaymentModal, setShowSuccessfulPaymentModal] =
		useState(false)
	const [registeredForWhat, setRegisteredForWhat] = useState()
	const [firstName, setFirstName] = useState()
	const [middleInitial, setMiddleInitial] = useState()
	const [lastName, setLastName] = useState()
	const [phoneNumber, setPhoneNumber] = useState()
	const [address, setAddress] = useState()
	const [city, setCity] = useState()
	const [state, setState] = useState()
	const [zip, setZip] = useState()
	const [country, setCountry] = useState()
	const [gender, setGender] = useState()
	const [email, setEmail] = useState()
	const [dateOfBirth, setDateOfBirth] = useState()
	const [teeShirtSize, setTeeShirtSize] = useState()
	const [parentName, setParentName] = useState()
	const [goalie, setGoalie] = useState()
	/* const [jerseyNumber, setJerseyNumber] = useState()
	const [position, setPosition] = useState() */
	const [dropdownArray, setDropdownArray] = useState()
	const [loadedRegistrationLeagues, setLoadedRegistrationLeagues] = useState()
	const [price, setPrice] = useState()
	//paypal stuff:
	const [show, setShow] = useState(false)
	const [success, setSuccess] = useState(false)
	const [ErrorMessage, setErrorMessage] = useState('')
	const [orderID, setOrderID] = useState(false)
	//
	const [willingToConcession, setWillingToConcession] = useState()
	const [willingToCoach, setWillingToCoach] = useState()
	const [willingToRef, setWillingToRef] = useState()
	const [willingToSponsor, setWillingToSponsor] = useState()
	const [agree, setAgree] = useState()
	const [disagree, setDisagree] = useState()
	const [agreedOrDisagreed, setAgreedOrDisagreed] = useState()

	//First, lets tap into the following route on the backend to get all
	//the different leagues that are available for registration
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL +
						`/registration/registrationLeagues`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedRegistrationLeagues(responseData.allCurrentRegistrationLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])

	/* if (loadedRegistrationLeagues) {
		console.log(loadedRegistrationLeagues)
	} */

	let registrationType

	const getRegistrationType = (event) => {
		registrationType = event.target.value
		setType(event.target.value)
		console.log('registrationType gotten: ' + registrationType)
		//
		//
		//Then here is where we CALL the secondDropdownFunction and feed it the registrationType
		secondDropdownFunction(registrationType)
	}
	const getRegisteredForWhat = (event) => {
		setRegisteredForWhat(event.target.value)
		console.log('registeredForWhat: ' + event.target.value)
		//
		//Now that we've determined exactly what they're signing up for, we need to display the price
		displayPrice(event.target.value)
	}
	const getFirstName = (event) => {
		setFirstName(event.target.value)
	}
	const getMiddleInitial = (event) => {
		setMiddleInitial(event.target.value)
	}
	const getLastName = (event) => {
		setLastName(event.target.value)
	}
	const getPhoneNumber = (event) => {
		setPhoneNumber(event.target.value)
	}
	const getAddress = (event) => {
		setAddress(event.target.value)
	}
	const getCity = (event) => {
		setCity(event.target.value)
	}
	const getState = (event) => {
		setState(event.target.value)
	}
	const getZip = (event) => {
		setZip(event.target.value)
	}
	const getCountry = (event) => {
		setCountry(event.target.value)
	}
	const getGender = (event) => {
		setGender(event.target.value)
	}
	const getEmail = (event) => {
		setEmail(event.target.value)
	}
	const getDOB = (event) => {
		setDateOfBirth(event.target.value)
	}
	const getTeeShirtSize = (event) => {
		setTeeShirtSize(event.target.value)
	}
	const getParentName = (event) => {
		setParentName(event.target.value)
	}
	const getGoalie = (event) => {
		setGoalie(event.target.value)
	}
	/* const getJerseyNumber = (event) => {
		setJerseyNumber(event.target.value)
	}
	const getPosition = (event) => {
		setPosition(event.target.value)
	} */
	//
	//
	let navigate = useNavigate()
	//
	//
	let typesArray, uniqueTypeArray, duplicateFilter, secondDropdownArray
	typesArray = []
	uniqueTypeArray = []
	secondDropdownArray = []
	//
	//
	//
	//
	if (loadedRegistrationLeagues && !isLoading) {
		loadedRegistrationLeagues.forEach((league) => {
			typesArray.push(league.type)
		})
		duplicateFilter = typesArray.filter((type) => {
			if (!uniqueTypeArray.includes(type)) {
				uniqueTypeArray.push(type)

				return true
			}
			return false
		})
	}
	//
	//
	//
	//
	//
	//
	const secondDropdownFunction = async (registrationType) => {
		setIsLoading(true)
		loadedRegistrationLeagues.forEach((league) => {
			if (league.type === registrationType) {
				secondDropdownArray.push(league.leagueNameAndDesc)
			}
		})
		setDropdownArray(secondDropdownArray)
		setIsLoading(false)
	}
	//
	//
	//
	//
	//let price
	const displayPrice = async (registeredForWhat) => {
		loadedRegistrationLeagues.forEach((type) => {
			if (type.leagueNameAndDesc === registeredForWhat) {
				setPrice(type.leaguePrice)
			}
		})
	}
	//
	//
	//goes to playerRegistration in the backend, registration-controller
	//
	const registerSubmitHandler = async (email, transactionId) => {
		console.log('inside registerSubmitHandler')
		try {
			setIsLoading(true)
			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/registration/playerRegistration',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						type,
						registeredForWhat,
						firstName,
						middleInitial,
						lastName,
						phoneNumber,
						address,
						city,
						state,
						zip,
						country,
						gender,
						email: email,
						transactionId: transactionId,
						dateOfBirth,
						teeShirtSize,
						parentName,
						goalie,
						willingToConcession,
						willingToCoach,
						willingToRef,
						willingToSponsor,
						agree,
						disagree,
					}),
				}
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error('ERROR: ' + responseData.message)
			}
			//setSuccess(true)
			setIsLoading(false)
			//price < 1 && showSuccessfulPaymentHandler()
			showSuccessfulPaymentHandler()
		} catch (err) {
			console.log('error: ' + err)
			setIsLoading(false)
			setError(
				err.message + ': Something went wrong with creating a registration.'
			)
		}
	}
	//
	//
	//
	//
	//
	const paypalErrorHander = async (data) => {
		console.log('inside paypalErrorHander')
		try {
			setIsLoading(true)
			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/registration/paypalError',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						data,
					}),
				}
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error('PayPal Error ERROR: ' + responseData.message)
			}
			setIsLoading(false)
		} catch (err) {
			console.log('paypal error error: ' + err)
			setIsLoading(false)
			setError(
				err.message +
					': Something went wrong with creating a paypal error instance in the database'
			)
		}
	}
	//
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//When user clicks OKAY on the popup modal (popup that says their payment was successful)
	//all this does is A: close the popup, and B: go back to the home page
	const okHandler = () => {
		setShowSuccessfulPaymentModal(null)
		navigate('/')
	}
	//
	//
	//
	const showSuccessfulPaymentHandler = () => {
		setShowSuccessfulPaymentModal(true)
	}
	//
	//
	const willingToConcessionCheckbox = (e) => {
		setWillingToConcession(true)
	}
	const willingToCoachCheckbox = (e) => {
		setWillingToCoach(true)
	}
	const willingToRefCheckbox = (e) => {
		setWillingToRef(true)
	}
	const willingToSponsorCheckbox = (e) => {
		setWillingToSponsor(true)
	}
	const agreeCheckbox = (e) => {
		if (agree) {
			setAgree(false)
			if (disagree) {
				setAgreedOrDisagreed(true)
			} else {
				setAgreedOrDisagreed(false)
			}
		} else {
			setAgree(true)
			setAgreedOrDisagreed(true)
		}
		//setAgreedOrDisagreed(true)
	}
	const disagreeCheckbox = (e) => {
		if (disagree) {
			setDisagree(false)
			if (agree) {
				setAgreedOrDisagreed(true)
			} else {
				setAgreedOrDisagreed(false)
			}
		} else {
			setDisagree(true)
			setAgreedOrDisagreed(true)
		}
		//setAgreedOrDisagreed(true)
	}
	//
	//
	//******************************************************************************** */
	//
	//    PayPal stuff...
	//
	//
	//******************************************************************************** */
	//
	//
	//
	const showPayPal = async (event) => {
		event.preventDefault()
		setShow(true)
	}
	//
	//
	//
	// creates a paypal order
	const createOrder = (data, actions) => {
		console.log('You are now inside createOrder...')
		//At this point, user is filling in their credit card/billing information...
		return actions.order
			.create({
				purchase_units: [
					{
						description: lastName + ' ' + registeredForWhat,
						amount: {
							currency_code: 'USD',
							value: price,
						},
					},
				],
			})
			.then((orderID) => {
				setOrderID(orderID)
				return orderID
			})
	}

	// check Approval
	const onApprove = (data, actions) => {
		return actions.order.capture().then(function (details) {
			setSuccess(true)
			registerSubmitHandler(
				details.payer.email_address,
				details.purchase_units[0].payments.captures[0].id
			)
			console.log('data: ' + JSON.stringify(data))
			console.log('details: ' + JSON.stringify(details))
			//console.log(
			//	'merchant transaction id: ' +
			//		JSON.stringify(details.purchase_units[0].payments.captures[0].id)
			//)
		})
	}

	//capture likely error
	const onError = (data, actions) => {
		setErrorMessage('An Error occured with your payment ')
		console.log('ERROR!!!!!!!!!!!!!!!!!!!!!!!: ' + JSON.stringify(data))
		paypalErrorHander(JSON.stringify(data))
	}
	//
	//
	//
	//
	//  Do I even need this?
	useEffect(() => {
		if (success) {
			console.log('Order successful . Your order id is--', orderID)
		}
	}, [success, orderID])
	//
	//
	//
	//
	//
	//
	//
	//
	//

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<Modal
					show={showSuccessfulPaymentModal}
					header='Payment Successful'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText'>Thank you for your payment.</p>
							<p className='modalText'>
								PayPal will be emailing your receipt shortly.
							</p>
							<p className='modalText'>Now, let's get ready to PLAY!!</p>
							<br></br>
							<button
								className='okButton buttonButton'
								inverse
								onClick={okHandler}
							>
								OKAY
							</button>
						</React.Fragment>
					}
				></Modal>
				<ErrorModal error={error} onClear={errorHandler} />
				<div>
					{isLoading && <LoadingSpinner asOverlay />}
					<main>
						<h2>Register a Player</h2>
						<div className='rcard'>
							{/* <div className='rcard-header'>
							<h2>Registrant Information</h2>
						</div> */}
							<div className='rcard-body rcard-padding'>
								<form className='register-form' onSubmit={showPayPal}>
									{!isLoading && loadedRegistrationLeagues && (
										<div>
											<div className='row' style={{ paddingBottom: '2rem' }}>
												<div className='form-group fg-line net'>
													<label
														htmlFor='txtTeamName'
														style={{ fontWeight: 'bold' }}
													>
														What are you registering for?
														<span className='c-red'>*</span>
													</label>
													<select
														name='ctl00$cphBody$drpMyTeam'
														id='ctl00_cphBody_drpMyTeam'
														onChange={getRegistrationType}
														tabIndex='2'
														className='dropdownElement textbox'
														required
													>
														<option defaultValue></option>
														{duplicateFilter.map((type, i) => (
															<option value={type} key={i}>
																{type.toUpperCase()}
															</option>
														))}
													</select>
												</div>
											</div>
											{dropdownArray && (
												<div className='row' style={{ paddingBottom: '2rem' }}>
													<div className='form-group fg-line net'>
														<label
															htmlFor='txtTeamName'
															style={{ fontWeight: 'bold' }}
														>
															Division Name<span className='c-red'>*</span>
														</label>
														<select
															name='ctl00$cphBody$drpMyTeam'
															id='ctl00_cphBody_drpMyTeam'
															onChange={getRegisteredForWhat}
															tabIndex='2'
															className='dropdownElement textbox'
															required
														>
															<option defaultValue></option>
															{dropdownArray.map((league, i) => (
																<option value={league} key={i}>
																	{league}
																</option>
															))}
														</select>
														{price && (
															<label
																htmlFor='txtPrice'
																style={{
																	marginLeft: '4rem',
																	fontWeight: 'bold',
																	color: 'red',
																}}
															>
																Price: ${price}
															</label>
														)}
													</div>
												</div>
											)}
										</div>
									)}
									<div className='row'>
										<div className='row'>
											<div className='col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtFirstName'
														style={{ fontWeight: 'bold' }}
													>
														Player First Name: <span className='c-red'>*</span>
													</label>
													<input
														name='ctl00$cphBody$txtFirstName'
														type='text'
														id='txtFirstName'
														tabIndex='6'
														className='rform-control'
														placeholder='First Name'
														onChange={getFirstName}
														required
													/>
												</div>
											</div>
											<div className='col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtMiddleInitial'
														style={{ fontWeight: 'bold' }}
													>
														Middle Initial:
													</label>
													<input
														name='ctl00$cphBody$txtMiddleInitial'
														type='text'
														maxLength={1}
														id='txtMiddleInitial'
														tabIndex='6'
														className='rform-control'
														placeholder='Middle Initial'
														onChange={getMiddleInitial}
													/>
												</div>
											</div>
											<div className='col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtLastName'
														style={{ fontWeight: 'bold' }}
													>
														Player Last Name: <span className='c-red'>*</span>
													</label>
													<input
														name='ctl00$cphBody$txtLastName'
														type='text'
														id='txtLastName'
														tabIndex='7'
														className='rform-control'
														onChange={getLastName}
														placeholder='Last Name'
														required
													/>
												</div>
											</div>
										</div>
									</div>
									<div className='row'>
										<div className='col-sm-3'>
											<div
												className='form-group fg-line net'
												style={{ marginBottom: '2rem' }}
											>
												<label
													htmlFor='txtHomePhone'
													style={{ fontWeight: 'bold' }}
												>
													Phone Number: <span className='c-red'>*</span>
												</label>
												<input
													name='ctl00$cphBody$txtHomePhone'
													type='text'
													id='txtHomePhone'
													tabIndex='8'
													className='rform-control'
													placeholder='Home Phone'
													onChange={getPhoneNumber}
													required
												/>
											</div>
										</div>
										<div className='col-md-5 col-sm-4'></div>
										<div className='col-sm-3'>
											<div
												className='form-group fg-line net'
												style={{ marginBottom: '2rem' }}
											>
												<label htmlFor='parent' style={{ fontWeight: 'bold' }}>
													Parents Name:
												</label>
												<input
													id='parent'
													type='text'
													tabIndex='9'
													placeholder='Parents Name'
													className='rform-control'
													onChange={getParentName}
												/>
											</div>
										</div>
									</div>
									<div className='row'>
										<div className='col-sm-3'>
											<div
												className='form-group fg-line net'
												style={{ marginBottom: '2rem' }}
											>
												<label htmlFor='gender' style={{ fontWeight: 'bold' }}>
													Gender:
												</label>
												<select
													className='dropdownElement'
													name='gender'
													tabIndex='10'
													onChange={getGender}
												>
													<option value=''></option>
													<option value='female'>Female</option>
													<option value='male'>Male</option>
													<option value='Prefer not to answer'>
														Prefer not to Answer
													</option>
												</select>
											</div>
										</div>
										<div className='col-md-5 col-md-4'></div>
									</div>
									{/* //
								//
								//
								//
								// */}
									<div>
										<div className='row'>
											<div className='col-sm-3'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label htmlFor='dob' style={{ fontWeight: 'bold' }}>
														Date of Birth: <span className='c-red'>*</span>
													</label>
													<input
														type='date'
														id='dob'
														name='dob'
														tabIndex='12'
														onChange={getDOB}
														required
													/>
												</div>
											</div>
											<div className='col-md-5 col-sm-4'></div>
											<div className='col-sm-3'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='tshirt'
														style={{ fontWeight: 'bold' }}
													>
														T-Shirt Size <span className='c-red'>*</span>
													</label>
													<select
														className='dropdownElement'
														name='tshirt'
														tabIndex='13'
														onChange={getTeeShirtSize}
														required
													>
														<option value=''></option>
														<option value='Youth XXS'>Youth XXS</option>
														<option value='Youth XS'>Youth XS(2/4)</option>
														<option value='Youth Small'>
															Youth Small(6/8)
														</option>
														<option value='Youth Medium'>
															Youth Med.(10/12)
														</option>
														<option value='Youth Large'>
															Youth Large(14/16)
														</option>
														<option value='Youth XL'>Youth XL</option>
														<option value='Adult XS'>Adult XS</option>
														<option value='Adult Sm.'>Adult Small</option>
														<option value='Adult Med.'>Adult Med.</option>
														<option value='Adult Lg.'>Adult Large</option>
														<option value='Adult XL'>Adult XL</option>
														<option value='Adult XXL'>Adult XXL</option>
														<option value='Adult XXXL'>Adult XXXL</option>
													</select>
												</div>
											</div>
										</div>
									</div>
									{/* //
								//
								//
								//
								// */}
									<div>
										<div className='row'>
											<div className='col-sm-3'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='goalie'
														style={{ fontWeight: 'bold' }}
													>
														Goalie? (Full-time, part-time, like to, or never)
													</label>
													<input
														id='goalie'
														type='text'
														tabIndex='14'
														maxLength={100}
														className='rform-control'
														placeholder='Goalie?'
														onChange={getGoalie}
													/>
												</div>
											</div>
											<div className='col-md-5 col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												></div>
											</div>
											<div className='col-sm-3'>
												<div className='form-group fg-line net'></div>
											</div>
										</div>
									</div>
									<div>
										<div className='row'>
											<div className='col-sm-3'>
												<div className='form-group fg-line net'></div>
											</div>
											<div className='col-md-5 col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtLastName'
														style={{ fontWeight: 'bold' }}
													>
														Would you be interested in volunteering?
													</label>
													<div>
														<input
															id='concession1'
															type='checkbox'
															onChange={willingToConcessionCheckbox}
														/>
														<label>Concession</label>
													</div>
													<div>
														<input
															id='coach1'
															type='checkbox'
															onChange={willingToCoachCheckbox}
														/>
														<label>Coaching</label>
													</div>
													<div>
														<input
															id='ref1'
															type='checkbox'
															onChange={willingToRefCheckbox}
														/>
														<label>Referee</label>
													</div>
													<div>
														<input
															id='sponsor1'
															type='checkbox'
															onChange={willingToSponsorCheckbox}
														/>
														<label>Sponsorship</label>
													</div>
												</div>
											</div>
											<div className='col-sm-3'>
												<div className='form-group fg-line net'></div>
											</div>
										</div>
									</div>
									{/* //
								//
								//    disclaimer
								//
								// */}
									{phoneNumber &&
										firstName &&
										lastName &&
										teeShirtSize &&
										dateOfBirth && (
											<div>
												<div className='row'>
													<p>Dear Parent/Guardian,</p>
													<p>
														We are thrilled to have your child participate in
														our Memorial Park Ball Hockey Club. Before your
														child joins in on the fun, we kindly request you to
														read and acknowledge the following consent and
														waiver:{' '}
													</p>
													<p>
														I, the undersigned parent/guardian, hereby grant
														permission for my child to participate in the Spring
														2025 Youth Dek Hockey League organized by Memorial
														Park Ball Hockey Club. I understand the nature of
														the activities involved in the league and
														acknowledge that participation involves inherent
														risks, including but not limited to physical injury.{' '}
													</p>
													<p>
														In consideration for allowing my child to
														participate in the league, I agree to release,
														indemnify, and hold harmless Memorial Park Ball
														Hockey Club, its organizers, volunteers, and any
														affiliated sponsors from any and all liability,
														claims, demands, actions, or rights of action, which
														may arise from or in connection with my child's
														participation in the sport.{' '}
													</p>
													<p>
														I understand that Memorial Park Ball Hockey Club
														will take all reasonable precautions to ensure the
														safety of participants during the league and hold
														all required and necessary insurance,
														certifications, and clearances. However, I
														acknowledge that accidents and injuries may occur
														despite these precautions.
													</p>
													<p>
														I agree to ensure that my child follows all safety
														guidelines and instructions provided by the league
														organizers and staff. In the event of an emergency,
														I authorize Memorial Park Ball Hockey Club and its
														representatives to seek and administer medical
														treatment for my child.{' '}
													</p>
													<p>
														I acknowledge that photographs and videos may be
														taken during the league for promotional and
														informational purposes. I grant permission for my
														child's image to be used in such materials without
														compensation.{' '}
													</p>
												</div>
												<div className='underline-blue mb-4'></div>
												<div>
													<input
														id='agree1'
														type='checkbox'
														onChange={agreeCheckbox}
													/>
													<label className='ack'>
														I have read and understand the terms of this consent
														and waiver, and I voluntarily agree to its terms.
													</label>
												</div>
												<br></br>
												<br></br>
												<div>
													<input
														id='disagree1'
														type='checkbox'
														onChange={disagreeCheckbox}
													/>
													<label className='ack'>
														I <strong>DO NOT</strong> agree with the terms of
														this consent and waiver form and wish to be
														contacted directly by the league organizers.
													</label>
												</div>
											</div>
										)}
									{agreedOrDisagreed && price > 0 && (
										<div className='checkoutBtn'>
											<Button type='submit'>
												CHECKOUT {price && ' $' + price}
											</Button>
										</div>
									)}
									{agreedOrDisagreed && price < 1 && (
										<div>
											<label
												htmlFor='parent'
												style={{
													fontWeight: 'bold',
													marginTop: '2rem',
													color: 'red',
												}}
											>
												PLEASE ENTER YOUR EMAIL ADDRESS:
											</label>
											<input
												style={{ marginTop: '1.5rem' }}
												id='email'
												type='text'
												tabIndex='9'
												placeholder='johnsmith@example.com'
												className='rform-control'
												onChange={getEmail}
											/>
											{email && (
												<button
													style={{ marginTop: '2rem' }}
													className='buttonButton'
													onClick={(e) =>
														//registerSubmitHandler('goalie@email.com', 'FREE')
														registerSubmitHandler(email, 'FREE')
													}
												>
													REGISTER
												</button>
											)}
										</div>
									)}
									<PayPalScriptProvider
										options={{
											'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
										}}
									>
										<div>
											<div className='wrapper'>
												<div className='product-img'></div>
												<div className='product-info'>
													<div className='product-text'>{/* <h1></h1> */}</div>
													<div className='product-price-btn'>
														<br></br>
														{/* <button
														className='buy-btn'
														type='submit'
														onClick={() => setShow(true)}
													>
														Buy now
													</button> */}
													</div>
												</div>
											</div>
											<br></br>
											{show ? (
												<PayPalButtons
													fundingSource='card'
													style={{ layout: 'vertical' }}
													createOrder={createOrder}
													onApprove={onApprove}
													onError={onError}
												/>
											) : null}
										</div>
									</PayPalScriptProvider>
								</form>
							</div>
						</div>
					</main>
				</div>
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default Register
